export default "__VITE_ASSET__CXproLal__"